export default __webpack_public_path__ + "static/Group57-358453ac8bbc0cca7daf47d1f9d2faa9.svg";